<script setup>
import Layout from "../../../layouts/main.vue";
import { onMounted, reactive, ref } from "vue";
import { useRouter, useRoute } from "vue-router";
import { FormInstance } from "element-plus";
import MethodService from "../../../service/MethodService";
import DataForm from "./dataFormDynamicConfigTable";
import mushroom from "cem-primary-api";
import Swal from "sweetalert2";
import toastr from "toastr";
import { useI18n } from "vue-i18n";
import { Filter, Project } from "mushroomjs";
const { t } = useI18n();
const ruleFormRef = ref(FormInstance);

let loading = ref(true);
const router = useRouter();
const route = useRoute();
const tableRules = reactive(MethodService.copyObject(DataForm.tableRules));
const dataTables = reactive({ value: [] });
const pageSizeDefault = ref(20);
const roles = ref([]);

// hiển thị form tìm kiếm
const fn_showFormSearchData = () => {
  tableRules.showFormSearch = !tableRules.showFormSearch;
};

// tìm kiếm
const fn_searchData = (formEl) => {
  if (!formEl) return;
  formEl.validate(async (valid) => {
    if (valid) {
      loading.value = true;
      if (tableRules.dataSearch.value["name"])
        tableRules.dataSearch.value["name"] =
          tableRules.dataSearch.value["name"].trim();
      if (tableRules.dataSearch.value["name_lang.vi"])
        tableRules.dataSearch.value["name_lang.vi"] =
          tableRules.dataSearch.value["name_lang.vi"].trim();
      if (tableRules.dataSearch.value["name_lang.en"])
        tableRules.dataSearch.value["name_lang.en"] =
          tableRules.dataSearch.value["name_lang.en"].trim();

      tableRules.filters = MethodService.filterTable(
        JSON.stringify(tableRules.dataSearch),
      );
      tableRules.offset = 0;
      tableRules.sort = "";
      fn_getListDynamicConfigTable();
    } else return false;
  });
};

// phân trang
const fn_tableSizeChange = (limit) => {
  tableRules.limit = limit;
  pageSizeDefault.value = limit;
  fn_tableChangeOffset(tableRules.page);
};
const fn_tableCurentChange = (page) => {
  fn_tableChangeOffset(page);
};
const fn_tablePrevClick = (page) => {
  fn_tableChangeOffset(page - 1);
};
const fn_tableNextClick = (page) => {
  fn_tableChangeOffset(page + 1);
};
const fn_tableChangeOffset = (page) => {
  tableRules.page = page;
  tableRules.offset = (tableRules.page - 1) * pageSizeDefault.value;
  fn_getListDynamicConfigTable();
};
const fn_tableSortChange = (column) => {
  MethodService.tableSortChange(column, tableRules);
  loading.value = true;
  fn_getListDynamicConfigTable();
};

const fn_hashUrl = () => {
  MethodService.hashUrl(route.query, tableRules);
  pageSizeDefault.value = tableRules.limit;
};

// chuyển sang màn thêm mới
const fn_addNew = () => {
  router.push({ name: "ThemMoiDynamicConfigTable" });
};

// lấy danh sách
const fn_getListDynamicConfigTable = async () => {
  router
    .replace({
      name: "DanhSachDynamicConfigTable",
      query: {
        limit: tableRules.limit,
        page: tableRules.page,
        sort: tableRules.sort,
        filters: tableRules.filters,
        showFormSearch: tableRules.showFormSearch,
      },
    })
    .catch(() => {});
  mushroom.dynamic_config_table.invalidCache();
  try {
    const response = await mushroom.dynamic_config_table.listAsync({
      filters: tableRules.filters,
      fields: tableRules.fields,
      limit: tableRules.limit,
      offset: tableRules.offset,
      sort: tableRules.sort,
    });
    if (response.result) {
      dataTables.value = response.result;
      tableRules.total = response.meta.total;
      tableRules.page = response.meta.offset / response.meta.limit + 1;
    }
  } catch (e) {
    MethodService.showError(e.code);
  } finally {
    loading.value = false;
  }
};

// xử lý thao tác
const fn_handle = (type, scope, row) => {
  if (type == "update") {
    router.push({
      name: "CapNhatDynamicConfigTable",
      params: { id: row.id },
    });
  }
  if (type == "delete") {
    Swal.fire({
      title: t("t_warning"),
      text: t("t-dynamic-config-table-delete-confirm"),
      icon: "warning",
      confirmButtonColor: "#f46a6a",
      confirmButtonText: t("swal_accept"),
      cancelButtonText: t("swal_cancel"),
      showCancelButton: true,
      allowOutsideClick: false,
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await mushroom.dynamic_config_table.deleteAsync({
            id: row.id,
          });
          if (response.result) {
            fn_getListDynamicConfigTable();
            toastr.success(t("toastr_delete_success"));
          }
        } catch (e) {
          if (
            e.code === 500 &&
            e.subCode === 2001 &&
            e.meta?.dynamic_config_page_ids?.length > 0
          ) {
            // Lấy tên các trang cấu hình động đang dùng bảng này
            let pageNames = [];
            try {
              const pageIds = e.meta.dynamic_config_page_ids;
              const lang = localStorage.getItem("language") || "vi";
              const pageRes = await mushroom.dynamic_config_page.getAllAsync({
                filters: Filter.in("id", pageIds).build(),
                fields: Project.include("id", "name", "name_lang"),
              });
              if (pageRes.result?.length > 0) {
                pageNames = pageRes.result.map((p, idx) => {
                  const name = p.name || (p.name_lang && p.name_lang[lang]) || p.id;
                  return `<li style="text-align:left;padding:4px 0">${
                    idx + 1
                  }. <strong>${name}</strong></li>`;
                });
              }
            } catch (e) {
              console.log("Lỗi lấy danh sách dynamic page", e);
            }

            const listHtml =
              pageNames.length > 0
                ? `<ul style="margin:8px 0 0 0;padding:0;list-style:none">${pageNames.join(
                    "",
                  )}</ul>`
                : "";

            Swal.fire({
              title: t("t-dynamic-config-table-in-use-title"),
              html: `<p style="margin-bottom:8px">${t(
                "t-dynamic-config-table-in-use-desc",
              )}</p>${listHtml}`,
              icon: "error",
              confirmButtonColor: "#405189",
              confirmButtonText: t("swal_accept"),
              allowOutsideClick: false,
            });
          } else {
            MethodService.showError(e.code);
          }
        }
      }
    });
  }
};

// Lấy link icon thumbnail
const getIconUrl = (iconId) => {
  if (!iconId) return null;
  return MethodService.thumbIcon(iconId, 24);
};

onMounted(async () => {
  fn_hashUrl();
  await fn_getListDynamicConfigTable();
  const response = JSON.parse(localStorage.getItem("userInfo"));
  roles.value = response?.result?.roles || [];
});
</script>

<template>
  <Layout>
    <div class="card" style="min-height: 80vh">
      <div class="card-header">
        <h3 class="text-uppercase mb-0">
          {{ $t("t-dynamic-config-table-title") }}
        </h3>
        <div class="text-end">
          <div class="btn-header">
            <button
              class="btn btn-soft-secondary btn-border me-2"
              @click="fn_showFormSearchData()"
            >
              <i class="ri-search-line"></i>
              {{ $t("t-search") }}
            </button>
            <button class="btn btn-secondary btn-border" @click="fn_addNew">
              <i class="ri-add-circle-line"></i>
              {{ $t("t-add") }}
            </button>
          </div>
        </div>
      </div>
      <div class="card-body" style="padding: 0 0 15px 0">
        <div class="main-body">
          <div class="main-body-search mx-3 mb-3">
            <b-collapse
              v-model="tableRules.showFormSearch"
              id="myFormSearch"
              class="b-shadow"
            >
              <b-card>
                <el-form
                  label-position="top"
                  ref="ruleFormRef"
                  @submit.prevent
                  :model="tableRules.dataSearch.value"
                >
                  <b-row>
                    <b-col md="3">
                      <el-form-item :label="$t('t-dynamic-config-table-name')">
                        <el-input
                          clearable
                          size="large"
                          v-model="tableRules.dataSearch.value['name']"
                          :placeholder="
                            $t('t-dynamic-config-table-name-placeholder')
                          "
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="3">
                      <el-form-item
                        :label="$t('t-dynamic-config-table-name-vi')"
                      >
                        <el-input
                          clearable
                          size="large"
                          v-model="tableRules.dataSearch.value['name_lang.vi']"
                          :placeholder="
                            $t('t-dynamic-config-table-name-vi-placeholder')
                          "
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="3">
                      <el-form-item
                        :label="$t('t-dynamic-config-table-name-en')"
                      >
                        <el-input
                          clearable
                          size="large"
                          v-model="tableRules.dataSearch.value['name_lang.en']"
                          :placeholder="
                            $t('t-dynamic-config-table-name-en-placeholder')
                          "
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="3">
                      <el-form-item label="&nbsp;">
                        <a
                          class="btn btn-soft-secondary btn-border mx-3"
                          style="width: 80px"
                          @click="fn_showFormSearchData()"
                        >
                          {{ $t("t-hide") }}
                        </a>
                        <button
                          class="btn btn-secondary bg-gradient btn-border waves-effect waves-light"
                          style="width: 100px"
                          native-type="submit"
                          type="submit"
                          @click="fn_searchData(ruleFormRef)"
                        >
                          {{ $t("t-search") }}
                        </button>
                      </el-form-item>
                    </b-col>
                  </b-row>
                </el-form>
              </b-card>
            </b-collapse>
          </div>
          <div class="mb-3" style="float: right">
            <el-pagination
              small
              v-model:currentPage="tableRules.page"
              v-model:page-size="pageSizeDefault"
              :page-sizes="tableRules.lengthMenu"
              background
              layout="total, sizes, prev, pager, next, jumper"
              :total="tableRules.total"
              @size-change="fn_tableSizeChange"
              @current-change="fn_tableCurentChange"
              @prev-click="fn_tablePrevClick"
              @next-click="fn_tableNextClick"
            />
          </div>
          <el-table
            size="small"
            :data="dataTables.value"
            style="width: 100%"
            min-height="550"
            v-loading="loading"
            @sort-change="fn_tableSortChange"
            :default-sort="{
              prop: tableRules.defaultSort[0],
              order: tableRules.defaultSort[1],
            }"
          >
            <el-table-column
              prop=""
              :label="$t('t-stt')"
              width="60"
              align="center"
            >
              <template #default="scope">
                <div class="text-center">
                  {{ tableRules.offset + scope.$index + 1 }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="icon" label="Icon" width="80" align="center">
              <template #default="scope">
                <img
                  v-if="scope.row.icon"
                  :src="getIconUrl(scope.row.icon)"
                  alt="icon"
                />
                <img v-else src="@/assets/icon/none-icon-svg.svg" alt="" height="24" width="24" />
              </template>
            </el-table-column>
            <el-table-column
              prop="name"
              :label="$t('t-dynamic-config-table-name')"
              min-width="200"
              align="start"
              :sortable="true"
            />
            <el-table-column
              prop="name_lang.vi"
              :label="$t('t-dynamic-config-table-name-vi')"
              min-width="200"
              align="start"
            >
              <template #default="scope">
                {{ scope.row.name_lang?.vi || "" }}
              </template>
            </el-table-column>
            <el-table-column
              prop="name_lang.en"
              :label="$t('t-dynamic-config-table-name-en')"
              min-width="200"
              align="start"
            >
              <template #default="scope">
                {{ scope.row.name_lang?.en || "" }}
              </template>
            </el-table-column>
            <el-table-column
              :label="$t('t-action')"
              align="center"
              width="120px"
            >
              <template #default="scope">
                <div class="btn-group-thao-tac">
                  <el-tooltip
                    class="box-item"
                    effect="light"
                    :content="$t('action_option')"
                    placement="top"
                  >
                    <button
                      type="button"
                      class="btn btn-soft-success waves-effect waves-light btn-sm"
                      @click="fn_handle('update', scope.$index, scope.row)"
                    >
                      <i class="ri-edit-box-line"></i>
                    </button>
                  </el-tooltip>

                  <el-tooltip
                    class="box-item"
                    effect="light"
                    :content="$t('action_delete')"
                    placement="top"
                  >
                    <button
                      v-if="roles.includes('Admin')"
                      type="button"
                      class="btn btn-soft-danger waves-effect waves-light btn-sm"
                      @click="fn_handle('delete', scope.$index, scope.row)"
                    >
                      <i class="ri-delete-bin-6-line"></i>
                    </button>
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <div class="mt-3" style="float: right">
            <el-pagination
              small
              v-model:currentPage="tableRules.page"
              v-model:page-size="pageSizeDefault"
              :page-sizes="tableRules.lengthMenu"
              background
              layout="total, sizes, prev, pager, next, jumper"
              :total="tableRules.total"
              @size-change="fn_tableSizeChange"
              @current-change="fn_tableCurentChange"
              @prev-click="fn_tablePrevClick"
              @next-click="fn_tableNextClick"
            />
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
